/*eslint-disable */
import cacheLs from '../cacheLs'

export default {
  setChatbotPromptResponse(state, response) {
    cacheLs.set_chatbot_prompt_response(response);
    state.chatbotPromptResponse = response;
    state.lastUpdatedTime = new Date().getTime();
  },
  removeChatbotPromptResponse(state) {
    cacheLs.remove_chatbot_prompt_response();
    state.chatbotPromptResponse = null;
    state.lastUpdatedTime = null;
  }
}